export default "__VITE_ASSET__DSYS9Yz2__"